import {Grid} from '@mui/material'
import React, {useState} from 'react'
import {DatePicker, LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterMoment} from '@mui/x-date-pickers/AdapterMoment'
import {DateValidationError} from '@mui/x-date-pickers/models';
import {DateFormats} from '../../constants/securspace-constants';
import moment, {Moment, MomentInput} from 'moment';

interface FromToDatePickerProps {
  fromDate: MomentInput;
  setFromDate: (date: Moment | null) => void;
  toDate: MomentInput;
  setToDate: (date: Moment | null) => void;
  disablePast?: boolean;
  showEndDate?: boolean;
  disabled?: boolean;
  minToDate?: MomentInput;
  startEndLabel?: boolean;
  disableFuture?: boolean;
}

/**
 * Component for selecting From and To dates.
 * Supports disabling past and future dates, hiding the end date, and setting a minimum end date.
 * @param fromDate {Object | string} - The start date
 * @param setFromDate {function} - Function to set the start date
 * @param toDate
 * @param setToDate
 * @param disablePast
 * @param showEndDate
 * @param disabled
 * @param minToDate
 * @param startEndLabel
 * @param disableFuture
 * @constructor
 */
const FromToDatePicker = ({
                            fromDate,
                            setFromDate,
                            toDate,
                            setToDate,
                            disablePast = false,
                            showEndDate = true,
                            disabled = false,
                            minToDate,
                            startEndLabel = false,
                            disableFuture = false
                          }: FromToDatePickerProps) => {
  const [error, setError] = useState<DateValidationError | null>(null);
  const minDateMessage = "Date cannot be before start date";

  let errorMessage = '';
  switch (error) {
    case 'maxDate':
    case 'minDate': {
      errorMessage = minDateMessage;
      break;
    }
    case 'invalidDate': {
      errorMessage = 'Your date is not valid';
      break;
    }
    default: {
      errorMessage = '';
    }
  }


  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <Grid item container className='ss-container-gap ss-from-to-date-picker'>
        <Grid item xs={12} md>
          <DatePicker
            label={startEndLabel ? "Start" : "From"}
            className="ss-date-from w-100"
            disabled={disabled}
            disablePast={disablePast}
            slotProps={{textField: {variant: "standard", helperText: errorMessage}}}
            value={moment(fromDate, DateFormats.DAY)}
            onChange={(date) => setFromDate(moment(date, DateFormats.DAY))}
            format={DateFormats.DAY}
            onError={(newError) => setError(newError)}
            disableFuture={disableFuture}
          />
        </Grid>
        {
          showEndDate && <Grid item xs={12} md>
            <DatePicker
              label={startEndLabel ? "End" : "To"}
              className='ss-date-to w-100'
              disabled={disabled}
              disablePast={disablePast}
              slotProps={{textField: {variant: "standard", helperText: errorMessage}}}
              onError={(newError) => setError(newError)}
              value={moment(toDate, DateFormats.DAY)}
              onChange={(date) => setToDate(moment(date, DateFormats.DAY))}
              format={DateFormats.DAY}
              minDate={moment(minToDate, DateFormats.DAY) || moment(fromDate, DateFormats.DAY)}
              disableFuture={disableFuture}
            />
          </Grid>
        }
      </Grid>
    </LocalizationProvider>
  )
};


export default FromToDatePicker;
